"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AdapterDateFns_1 = __importDefault(require("@mui/lab/AdapterDateFns"));
var LocalizationProvider_1 = __importDefault(require("@mui/lab/LocalizationProvider"));
var TimePicker_1 = __importDefault(require("@mui/lab/TimePicker"));
var DateTimePicker_1 = __importDefault(require("@mui/lab/DateTimePicker"));
var DesktopDatePicker_1 = __importDefault(require("@mui/lab/DesktopDatePicker"));
var material_1 = require("@mui/material");
var de_1 = __importDefault(require("date-fns/locale/de"));
var en_US_1 = __importDefault(require("date-fns/locale/en-US"));
var it_1 = __importDefault(require("date-fns/locale/it"));
var es_1 = __importDefault(require("date-fns/locale/es"));
var fr_1 = __importDefault(require("date-fns/locale/fr"));
var tr_1 = __importDefault(require("date-fns/locale/tr"));
var pt_1 = __importDefault(require("date-fns/locale/pt"));
var ru_1 = __importDefault(require("date-fns/locale/ru"));
var pl_1 = __importDefault(require("date-fns/locale/pl"));
var sv_1 = __importDefault(require("date-fns/locale/sv"));
var uk_1 = __importDefault(require("date-fns/locale/uk"));
var ro_1 = __importDefault(require("date-fns/locale/ro"));
var nb_1 = __importDefault(require("date-fns/locale/nb"));
var nl_1 = __importDefault(require("date-fns/locale/nl"));
var hu_1 = __importDefault(require("date-fns/locale/hu"));
var hr_1 = __importDefault(require("date-fns/locale/hr"));
var fi_1 = __importDefault(require("date-fns/locale/fi"));
var el_1 = __importDefault(require("date-fns/locale/el"));
var da_1 = __importDefault(require("date-fns/locale/da"));
var cs_1 = __importDefault(require("date-fns/locale/cs"));
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var schemaTypes_1 = require("../../../shared/types/schemaTypes");
var CrudeTextInputComponent_1 = __importDefault(require("./CrudeTextInputComponent"));
var LabelWithTooltipComponent_1 = __importDefault(require("../../../shared/components/MessageComponents/LabelWithTooltipComponent"));
var styles_1 = require("@mui/styles");
var CrudeDateTimeComponent = function (props) {
    var _a, _b, _c, _d, _e;
    var columnName = props.schema.name;
    var language = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var required = !props.schema.nullable;
    var columnLabels = (_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[props.entity]) === null || _b === void 0 ? void 0 : _b.columns;
    var label = (columnLabels && ((_c = columnLabels[columnName]) === null || _c === void 0 ? void 0 : _c.title)) ? (_d = columnLabels[columnName]) === null || _d === void 0 ? void 0 : _d.title : columnName;
    var description = columnLabels && ((_e = columnLabels[columnName]) === null || _e === void 0 ? void 0 : _e.description);
    var _f = react_1.default.useState(props.data), data = _f[0], setData = _f[1];
    var useStyles = styles_1.makeStyles(function (theme) { return ({
        input: {
            width: props.fullWidth ? '100%' : '300px',
            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.primary.main,
                borderWidth: 2,
            },
        },
    }); });
    var classes = useStyles();
    var prepareDate = function (date) {
        if (date) {
            var offset = 0;
            return new Date((date + (offset * 60)) * 1000);
        }
        return null;
    };
    var localeMap = {
        'en-US': en_US_1.default,
        'de-DE': de_1.default,
        'it-IT': it_1.default,
        'es-ES': es_1.default,
        'fr-FR': fr_1.default,
        'pt-PT': pt_1.default,
        'ru-RU': ru_1.default,
        'tr-TR': tr_1.default,
        'pl-PL': pl_1.default,
        'sv-SE': sv_1.default,
        'uk-UA': uk_1.default,
        'ro-RO': ro_1.default,
        'no-NO': nb_1.default,
        'nl-NL': nl_1.default,
        'hu-HU': hu_1.default,
        'hr-HR': hr_1.default,
        'fi-FI': fi_1.default,
        'el-GR': el_1.default,
        'da-DK': da_1.default,
        'cs-CZ': cs_1.default,
    };
    var _g = react_1.useState(null), value = _g[0], setValue = _g[1];
    react_1.useEffect(function () {
        setValue(props.data.data[columnName] ? prepareDate(props.data.data[columnName]) : null);
    }, [data]);
    react_1.useEffect(function () {
        setData(props.data);
    }, [props.data]);
    var changeData = function (date) {
        var newValue = date ? new Date(date) : null;
        var newTimestamp = date ? date.getTime() / 1000 : null;
        var newData = data;
        var newColumnData = newData.data;
        newColumnData[columnName] = newTimestamp;
        newData.data = newColumnData;
        setValue(newValue);
        setData(__assign({}, newData));
        props.onChange && props.onChange(newData);
    };
    var disabled = props.disabled ? props.disabled : false;
    return disabled ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CrudeTextInputComponent_1.default, { entity: props.entity, data: props.data, fullWidth: props.fullWidth, schema: props.schema, disabled: true }))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(LocalizationProvider_1.default, { dateAdapter: AdapterDateFns_1.default, locale: localeMap[language] },
            props.schema.columnType === schemaTypes_1.ColumnType.Date &&
                react_1.default.createElement(DesktopDatePicker_1.default, { label: react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: label, description: description }), value: value, onChange: changeData, renderInput: function (params) {
                        var _a;
                        return react_1.default.createElement(material_1.TextField, __assign({}, params, { variant: (_a = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _a === void 0 ? void 0 : _a.type, required: required, className: classes.input, label: react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: label, description: description }), InputLabelProps: {
                                shrink: true,
                                style: { pointerEvents: 'auto', display: 'flex', alignItems: 'center' },
                            } }));
                    } }),
            props.schema.columnType === schemaTypes_1.ColumnType.Time &&
                react_1.default.createElement(TimePicker_1.default, { label: react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: label, description: description }), value: value, onChange: changeData, renderInput: function (params) {
                        var _a;
                        return react_1.default.createElement(material_1.TextField, __assign({}, params, { variant: (_a = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _a === void 0 ? void 0 : _a.type, required: required, className: classes.input, label: react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: label, description: description }), InputLabelProps: {
                                shrink: true,
                                style: { pointerEvents: 'auto', display: 'flex', alignItems: 'center' },
                            } }));
                    } }),
            props.schema.columnType === schemaTypes_1.ColumnType.DateTime &&
                react_1.default.createElement(DateTimePicker_1.default, { label: react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: label, description: description }), value: value, onChange: changeData, renderInput: function (params) {
                        var _a;
                        return react_1.default.createElement(material_1.TextField, __assign({}, params, { variant: (_a = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _a === void 0 ? void 0 : _a.type, required: required, className: classes.input, label: react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: label, description: description }), InputLabelProps: {
                                shrink: true,
                                style: { pointerEvents: 'auto', display: 'flex', alignItems: 'center' },
                            } }));
                    } }))));
};
exports.default = CrudeDateTimeComponent;
